import React from 'react';
import styled from 'styled-components';

import { CurrentUser } from 'api/currentUser';
import { Box } from 'components/Box';
import { LinkButton, PrimaryButtonRouterLink } from 'components/Button';
import { Divider } from 'components/Divider';
import { Meter } from 'components/Meter';
import ResumeDatabaseResponseContainer from 'containers/ResumeDatabaseResponseContainer';
import { colors, fontWeights } from 'theme';
import { trackClicked } from 'utils/analytics';

const StyledLinkButton = styled(LinkButton)`
  color: ${colors.battleshipGrey};
  font-size: inherit;
  font-weight: ${fontWeights.normal};
  text-decoration: underline;
`;

type Props = {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  closeMenu: (...args: Array<any>) => any;
  currentUser: CurrentUser;
};

export function PageHeaderAccountDropdownProfileSection({
  closeMenu,
  currentUser,
}: Props) {
  return (
    <>
      <Divider light my={0} />
      <Box minWidth={200} px={12} pt={16} pb={24} textAlign="center">
        <Box mb="8px" color={colors.battleshipGrey}>
          {getText('Your profile is incomplete')}
        </Box>
        <Meter
          current={1}
          total={3}
          color="turtleGreen"
          delay={0}
          duration={0.5}
        />
        <Box mt={20} mb="8px">
          <PrimaryButtonRouterLink
            to="/dashboard/employment-profile/get-discovered"
            size="small"
            onClick={() => {
              closeMenu();
              trackClicked('Add Resume', {
                context: 'Header User Dropdown',
              });
            }}
          >
            {currentUser.resumeId
              ? getText('Share Resume')
              : getText('Add Resume')}
          </PrimaryButtonRouterLink>
        </Box>
        <Box
          width={1}
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          {/* @ts-expect-error ts-migrate(2786) FIXME: 'ResumeDatabaseResponseContainer' cannot be used a... Remove this comment to see the full error message */}
          <ResumeDatabaseResponseContainer>
            {({ dismiss }) => (
              <StyledLinkButton
                onClick={() => {
                  dismiss();
                  closeMenu();
                  trackClicked('Dismiss Resume Database CTA', {
                    context: 'Header User Dropdown',
                  });
                }}
              >
                {getText('No, thanks')}
              </StyledLinkButton>
            )}
          </ResumeDatabaseResponseContainer>
        </Box>
      </Box>
    </>
  );
}
